import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { RelatorioDTO } from '../../../../dtos/relatorio-dto';
import { Procedimento } from '../../../../procedimento/procedimento';
import { ProcedimentoService } from '../../../../procedimento/procedimento.service';
import { ChaveValorStrInterface } from '../../../../util/chave-valor-str-interface';
import { Util } from '../../../../util/util';
import { CustomDateValidator } from '../../../../validators/custom-date-validator';
import { RelatorioProcedimentoService } from '../../relatorio-procedimento.service';
import { Filial } from '../../../../filial/filial';
import { FilialService } from '../../../../filial/filial.service';

@Component({
  selector: 'app-rel-disponibilidade-vagas-procedimento',
  templateUrl: './rel-disponibilidade-vagas-procedimento.component.html',
  styleUrls: ['./rel-disponibilidade-vagas-procedimento.component.css']
})
export class RelDisponibilidadeVagasProcedimentoComponent implements OnInit {

  formularioDeDisponibilidadeDeVagas: FormGroup;

  listaFiliais: Filial[];

  listaTipoAgrupamentoDisponibilidadeDeVagasParaProcedimentos: ChaveValorStrInterface[];

  listaDeProcedimento: Procedimento[];

  constructor(private relatorioService: RelatorioProcedimentoService,
    private filialService: FilialService,
    private procedimentoService: ProcedimentoService,
    private formBuilder: FormBuilder) {

    this.formularioDeDisponibilidadeDeVagas = this.formBuilder.group({
      filial: ['', [Validators.required]],
      dataInicial: [''],
      dataFinal: [''],
      codTipoAgrupamento: ['0', [Validators.required]],
      procedimentos: ['', [Validators.required]],
    }, {
      validator: [CustomDateValidator('dataInicial'),
      CustomDateValidator('dataFinal')],
    });

    this.listaFiliais = [];

    this.listaTipoAgrupamentoDisponibilidadeDeVagasParaProcedimentos = Util.listaTipoAgrupamentoDisponibilidadeDeVagasParaProcedimentos;

    this.listaDeProcedimento = [];
  }

  ngOnInit() {

    this.listarFiliais();

    this.listarProcedimentos();
  }

  onSubmit() {
    this.gerarRelatorio();
  }

  gerarRelatorio(): void {

    const relatorioDTO: RelatorioDTO = Object.assign(new RelatorioDTO(), this.formularioDeDisponibilidadeDeVagas.value);

    const procedimentos: Procedimento[] = this.controlProcedimentos.value;
    const idsProcedimentos: number[] = [];

    procedimentos.forEach((element) => {
      idsProcedimentos.push(element.id);
    });

    relatorioDTO.idsNumberArray = idsProcedimentos;

    this.relatorioService.gerarRelatorioDeDisponibilidadeDeVagas(relatorioDTO)
      .subscribe((response: BlobPart) => {
        const file = new Blob([response], { type: 'application/pdf' });
        const fileURL = URL.createObjectURL(file);
        window.open(fileURL);
      });
  }

  listarFiliais() {
    this.filialService.semRelacionamento()
      .subscribe(data => {
        // console.log(data)
        this.listaFiliais = data;

      }, error => {
        console.log(error);
      });
  }

  listarProcedimentos() {
    this.procedimentoService.listarComProjecao()
      .subscribe(data => {
        // console.log(data)
        this.listaDeProcedimento = data;

      }, error => {
        console.log(error);
      });
  }

  get controlProcedimentos() {

    return this.formularioDeDisponibilidadeDeVagas.controls.procedimentos;

  }

}
